let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1yEgj")).then(() => parcelRequire('kEmC2'));